import { InputBaseComponentProps } from '@material-ui/core';
import { FieldValues } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';

import { TextFormFieldProps } from '@/components/shared/components/NewContextForms/TextFormField';
import { useCustomTheme } from '@/hooks/useCustomTheme';

import { TextFormField } from './TextFormField';

const NumberFormatCustom = ({ maxLength, allowDecimals, valueUnit, inputRef, onChange, ...props }) => (
  <NumericFormat
    {...props}
    getInputRef={inputRef}
    onValueChange={(values) => {
      onChange({
        target: {
          name: props.name,
          value: values.value,
        },
      });
    }}
    decimalSeparator={','}
    thousandSeparator={'.'}
    suffix={valueUnit ? ` ${valueUnit}` : ''}
    decimalScale={allowDecimals ? 2 : 0}
    fixedDecimalScale
    valueIsNumericString
    isAllowed={({ value }) => {
      return maxLength ? value.split('.')[0].length <= maxLength : true;
    }}
  />
);

interface NumberFormFieldProps<TFieldValues extends FieldValues> extends TextFormFieldProps<TFieldValues> {
  showIcon?: boolean;
  valueUnit?: string;
  allowDecimals?: boolean;
  maxLength?: number;
  markAsOptional?: boolean;
}

export function NumberFormField<TFieldValues extends FieldValues>({
  name,
  showIcon = false,
  valueUnit,
  allowDecimals = true,
  maxLength,
  ...props
}: NumberFormFieldProps<TFieldValues>) {
  const { palette } = useCustomTheme();

  return (
    <TextFormField
      name={name}
      {...props}
      defaultValue={props.type === 'number' ? Number(props.defaultValue) : props.defaultValue}
      InputProps={{
        inputComponent: NumberFormatCustom as InputBaseComponentProps['inputComponent'],
        inputProps: {
          onChange: (e) => {
            if (props.type === 'number') {
              e.target.value = Number(e.target.value);
            }
          },
          allowDecimals,
          maxLength,
          valueUnit,
        },
        endAdornment: showIcon ? (
          <i
            className="icon-edit-input"
            style={{
              pointerEvents: 'none',
              opacity: 0.5,
              verticalAlign: 'text-top',
              fontSize: '25px',
              color: palette.grey[700],
            }}
          ></i>
        ) : null,
        ...props?.InputProps,
      }}
    />
  );
}
